export default [
  {
    path: '/engine/modules/:moduleId/tabulations/:tabulationId',
    name: 'engine-tabulation-edit',
    component: () => import('./editTabulations.vue'),
    props: route => ({
      moduleId: route.params.moduleId,
      tabulationId: route.params.tabulationId,
      standalone: true,
    }),
    meta: { engine: true, requiresAdmin: true },
  },
]
